import React, { Component } from 'react'
import { Tabs, Tab, Grid, Cell, Card, CardTitle, CardText, CardActions, Button, IconButton, CardMenu } from 'react-mdl';

class Projetcs extends Component {
    constructor(props) {
        super(props);
        this.state = { activeTab: 0 };
    }
    toggleCategories() {
        if (this.state.activeTab === 0) {
            return (
                <div className="projects-grid">
                    <Grid>
                        <Cell col={4}>
                            <Card shadow={0} style={{ width: 'auto', margin: 'auto' }}>
                                <CardTitle style={{ color: 'Black', height: '176px', background: 'url(https://cdn.dribbble.com/users/65867/screenshots/1140744/open-web-platform-ios-icons.jpg) center / cover' }}></CardTitle>
                                <CardText>
                                <h5>WWW.X-HUB.IO</h5> site web de l'entreprise xhub<br/>
                                ROLE : Réalisation du site web avec l'user expériences<br/>
                                OUTILS : HTML5 , CSS3 , framework sass , javascript .
                </CardText>
                                <CardActions border style={{ textAlign: 'center' }}>
                                    <Button colored>Github</Button>
                                    <Button colored>Gitlab</Button>
                                    <Button colored>CodePen</Button>
                                </CardActions>
                                <CardMenu style={{ color: '#fff' }}>
                                    <IconButton name="share" />
                                </CardMenu>
                            </Card>
                        </Cell>
                        <Cell col={4}>
                            <Card shadow={0} style={{ width: 'auto', margin: 'auto' }}>
                                <CardTitle style={{ color: 'Black', height: '176px', background: 'url(https://cdn.dribbble.com/users/65867/screenshots/1140744/open-web-platform-ios-icons.jpg) center / cover' }}></CardTitle>
                                <CardText>
                                <h5>WWW.DEVOXX4KIDS.MA</h5>site web de l'association devoxx4kids .<br/>
                                ROLE : intégration du template .<br/>
                                OUTILS : HTML5 , CSS3 , Bootstrap , javascript .
                </CardText>
                                <CardActions border style={{ textAlign: 'center' }}>
                                    <Button colored>Github</Button>
                                    <Button colored>Gitlab</Button>
                                    <Button colored>CodePen</Button>
                                </CardActions>
                                <CardMenu style={{ color: '#fff' }}>
                                    <IconButton name="share" />
                                </CardMenu>
                            </Card>
                        </Cell>
                        <Cell col={4}>
                            <Card shadow={0} style={{ width: 'auto', margin: 'auto' }}>
                                <CardTitle style={{ color: 'Black', height: '176px', background: 'url(https://cdn.dribbble.com/users/65867/screenshots/1140744/open-web-platform-ios-icons.jpg) center / cover' }}></CardTitle>
                                <CardText>
                                <h5>WWW.FISHER SPLENDOR.COM</h5>site web du plateforme fishersplendor .<br/>
                                ROLE : intégration du template .<br/>
                                OUTILS : HTML5 , CSS3 , Bootstrap , javascript .
                </CardText>
                                <CardActions border style={{ textAlign: 'center' }}>
                                    <Button colored>Github</Button>
                                    <Button colored>Gitlab</Button>
                                    <Button colored>CodePen</Button>
                                </CardActions>
                                <CardMenu style={{ color: '#fff' }}>
                                    <IconButton name="share" />
                                </CardMenu>
                            </Card>
                        </Cell>
                    </Grid>
                </div>

            )
        } else if (this.state.activeTab === 1) {
            return (
                <Grid>
                    <Cell col={4}>
                        <Card shadow={0} style={{ width: 'auto', margin: 'auto' }}>
                            <CardTitle style={{ color: 'Black', height: '176px', background: 'url(https://miro.medium.com/max/700/1*dLaDL-lSN0iprzmOpmM7zQ.png) center / cover' }}></CardTitle>
                            <CardText>
                            <h5>My Portfolio</h5>Mon portfolio<br/>
                                OUTILS : React js .
        </CardText>
                            <CardActions border style={{ textAlign: 'center' }}>
                                <Button colored>Github</Button>
                                <Button colored>Gitlab</Button>
                                <Button colored>CodePen</Button>
                            </CardActions>
                            <CardMenu style={{ color: '#fff' }}>
                                <IconButton name="share" />
                            </CardMenu>
                        </Card>
                    </Cell>
                    <Cell col={4}>
                        <Card shadow={0} style={{ width: 'auto', margin: 'auto' }}>
                            <CardTitle style={{ color: 'Black', height: '176px', background: 'url(https://miro.medium.com/max/700/1*dLaDL-lSN0iprzmOpmM7zQ.png) center / cover' }}></CardTitle>
                            <CardText>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                                Mauris sagittis pellentesque lacus eleifend lacinia...
        </CardText>
                            <CardActions border style={{ textAlign: 'center' }}>
                                <Button colored>Github</Button>
                                <Button colored>Gitlab</Button>
                                <Button colored>CodePen</Button>
                            </CardActions>
                            <CardMenu style={{ color: '#fff' }}>
                                <IconButton name="share" />
                            </CardMenu>
                        </Card>
                    </Cell>
                    <Cell col={4}>
                        <Card shadow={0} style={{ width: 'auto', margin: 'auto' }}>
                            <CardTitle style={{ color: 'Black', height: '176px', background: 'url(https://miro.medium.com/max/700/1*dLaDL-lSN0iprzmOpmM7zQ.png) center / cover' }}></CardTitle>
                            <CardText>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                                Mauris sagittis pellentesque lacus eleifend lacinia...
        </CardText>
                            <CardActions border style={{ textAlign: 'center' }}>
                                <Button colored>Github</Button>
                                <Button colored>Gitlab</Button>
                                <Button colored>CodePen</Button>
                            </CardActions>
                            <CardMenu style={{ color: '#fff' }}>
                                <IconButton name="share" />
                            </CardMenu>
                        </Card>
                    </Cell>
                </Grid>
            )
        } else if (this.state.activeTab === 2) {
            return (
                <Grid>
                    <Cell col={4}>
                        <Card shadow={0} style={{ width: 'auto', margin: 'auto' }}>
                            <CardTitle style={{ color: 'Black', height: '176px', background: 'url(https://miro.medium.com/max/600/1*LHi-sCMgtDHsu3BAOsDiXw.jpeg) center / cover' }}></CardTitle>
                            <CardText>
                            <h5>GHUB</h5>PLATEFORME GAMING EN LIGNE .<br/>
                            ROLE : Testeur .<br/>
                            OUTILS : Selenium .
                </CardText>
                            <CardActions border style={{ textAlign: 'center' }}>
                                <Button colored>Github</Button>
                                <Button colored>Gitlab</Button>
                                <Button colored>CodePen</Button>
                            </CardActions>
                            <CardMenu style={{ color: '#fff' }}>
                                <IconButton name="share" />
                            </CardMenu>
                        </Card>
                    </Cell>
                    <Cell col={4}>
                        <Card shadow={0} style={{ width: 'auto', margin: 'auto' }}>
                            <CardTitle style={{ color: 'Black', height: '176px', background: 'url(https://miro.medium.com/max/600/1*LHi-sCMgtDHsu3BAOsDiXw.jpeg) center / cover' }}></CardTitle>
                            <CardText>
                            <h5>BOA</h5>Plateforme de gestion bancaire pour la Bank of africa .<br/>
                            ROLE : développement des tests d'intégration .<br/>
                            OUTILS : PostMan , selenium (webdriver , testng) .
                </CardText>
                            <CardActions border style={{ textAlign: 'center' }}>
                                <Button colored>Github</Button>
                                <Button colored>Gitlab</Button>
                                <Button colored>CodePen</Button>
                            </CardActions>
                            <CardMenu style={{ color: '#fff' }}>
                                <IconButton name="share" />
                            </CardMenu>
                        </Card>
                    </Cell>
                    <Cell col={4}>
                        <Card shadow={0} style={{ width: 'auto', margin: 'auto' }}>
                            <CardTitle style={{ color: 'Black', height: '176px', background: 'url(https://miro.medium.com/max/600/1*LHi-sCMgtDHsu3BAOsDiXw.jpeg) center / cover' }}></CardTitle>
                            <CardText>
                            <h5>SECUSID</h5>Application Desktop et Mobile de déclaration des incendies .<br/>
                            ROLE : develepement des tests d'intégration avec la documentation .<br/>
                            OUTILS : selenium(webdriver,testng),Soap .
                </CardText>
                            <CardActions border style={{ textAlign: 'center' }}>
                                <Button colored>Github</Button>
                                <Button colored>Gitlab</Button>
                                <Button colored>CodePen</Button>
                            </CardActions>
                            <CardMenu style={{ color: '#fff' }}>
                                <IconButton name="share" />
                            </CardMenu>
                        </Card>
                    </Cell>
                    <Cell col={4}>
                        <Card shadow={0} style={{ width: 'auto', margin: 'auto' }}>
                            <CardTitle style={{ color: 'Black', height: '176px', background: 'url(https://miro.medium.com/max/600/1*LHi-sCMgtDHsu3BAOsDiXw.jpeg) center / cover' }}></CardTitle>
                            <CardText>
                            <h5>FISHER SPLENDOR</h5>Application Mobile de Péche .<br/>
                            ROLE : Tester l'application pour les deux coté :<br/>
                            <b>coté Desktop</b> : Réalisation des documents de tests est donnée des
                             améliorations user experience .<br/>
                            <b>coté Mobile</b> : intégration et vérification des donné des spots, faire les tetsts
                            au fur est à mésure pendent le développement de l'application avec le
                            déplacement pour la vérification des donnés des Spots .
                </CardText>
                            <CardActions border style={{ textAlign: 'center' }}>
                                <Button colored>Github</Button>
                                <Button colored>Gitlab</Button>
                                <Button colored>CodePen</Button>
                            </CardActions>
                            <CardMenu style={{ color: '#fff' }}>
                                <IconButton name="share" />
                            </CardMenu>
                        </Card>
                    </Cell>
                    <Cell col={4}>
                        <Card shadow={0} style={{ width: 'auto', margin: 'auto' }}>
                            <CardTitle style={{ color: 'Black', height: '176px', background: 'url(https://miro.medium.com/max/600/1*LHi-sCMgtDHsu3BAOsDiXw.jpeg) center / cover' }}></CardTitle>
                            <CardText>
                            <h5>DEVMA</h5>Application d'un réseau Sociaux des développeurs comme LINKDINE .<br/>
                            ROLE : L'élaboration de tous les documents Tests pendant pendant la réalisation de l'application .<br/>
                            
                </CardText>
                            <CardActions border style={{ textAlign: 'center' }}>
                                <Button colored>Github</Button>
                                <Button colored>Gitlab</Button>
                                <Button colored>CodePen</Button>
                            </CardActions>
                            <CardMenu style={{ color: '#fff' }}>
                                <IconButton name="share" />
                            </CardMenu>
                        </Card>
                    </Cell>
                    <Cell col={4}>
                        <Card shadow={0} style={{ width: 'auto', margin: 'auto' }}>
                            <CardTitle style={{ color: 'Black', height: '176px', background: 'url(https://miro.medium.com/max/600/1*LHi-sCMgtDHsu3BAOsDiXw.jpeg) center / cover' }}></CardTitle>
                            <CardText>
                            <h5>DEVOXX REGISTRATION</h5>Plateforme d'enregistrement dans la grande conférence des développeurs dans la région Mea .<br/>
                            ROLE : Tester la Plateforme & faire des améliorations user expériences .
                            
                </CardText>
                            <CardActions border style={{ textAlign: 'center' }}>
                                <Button colored>Github</Button>
                                <Button colored>Gitlab</Button>
                                <Button colored>CodePen</Button>
                            </CardActions>
                            <CardMenu style={{ color: '#fff' }}>
                                <IconButton name="share" />
                            </CardMenu>
                        </Card>
                    </Cell>
                </Grid>
            )
        }
    }

    render() {
        return (
            <div className="category-tabs">
                <Tabs activeTab={this.state.activeTab} onChange={(tabId) => this.setState({ activeTab: tabId })} ripple>
                    <Tab>HTML5 / CSS3 / Javascript / Bootstrap</Tab>
                    <Tab>REACT JS</Tab>
                    <Tab>TEST DRIVEN DEVELOPMENT</Tab>
                </Tabs>
                <Grid>
                    <Cell col={12}>
                        <div className="content">{this.toggleCategories()}</div>
                    </Cell>
                </Grid>
            </div>
        )
    }
}
export default Projetcs;